import { render, staticRenderFns } from "./ColorContextMenu.vue?vue&type=template&id=46159036&scoped=true&"
import script from "./ColorContextMenu.vue?vue&type=script&lang=js&"
export * from "./ColorContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./ColorContextMenu.vue?vue&type=style&index=0&id=46159036&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46159036",
  null
  
)

export default component.exports